export class NativeStandardIntervalConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "intervalHours",
            "baseName": "intervalHours",
            "type": "NativeStandardIntervalConfigIntervalHoursEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardIntervalConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var NativeStandardIntervalConfigIntervalHoursEnum;
(function (NativeStandardIntervalConfigIntervalHoursEnum) {
    NativeStandardIntervalConfigIntervalHoursEnum[NativeStandardIntervalConfigIntervalHoursEnum["NUMBER_1"] = 1] = "NUMBER_1";
    NativeStandardIntervalConfigIntervalHoursEnum[NativeStandardIntervalConfigIntervalHoursEnum["NUMBER_2"] = 2] = "NUMBER_2";
    NativeStandardIntervalConfigIntervalHoursEnum[NativeStandardIntervalConfigIntervalHoursEnum["NUMBER_4"] = 4] = "NUMBER_4";
    NativeStandardIntervalConfigIntervalHoursEnum[NativeStandardIntervalConfigIntervalHoursEnum["NUMBER_6"] = 6] = "NUMBER_6";
    NativeStandardIntervalConfigIntervalHoursEnum[NativeStandardIntervalConfigIntervalHoursEnum["NUMBER_8"] = 8] = "NUMBER_8";
    NativeStandardIntervalConfigIntervalHoursEnum[NativeStandardIntervalConfigIntervalHoursEnum["NUMBER_12"] = 12] = "NUMBER_12";
})(NativeStandardIntervalConfigIntervalHoursEnum || (NativeStandardIntervalConfigIntervalHoursEnum = {}));
